import * as z from "zod";

export const ShopperAgentEmailConfigSchema = z.object({
  repliesEnabled: z.boolean().optional(),
});

export type ShopperAgentEmailConfig = z.infer<
  typeof ShopperAgentEmailConfigSchema
>;
